import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../utils'

export const GET_PROFILES_REQUEST = 'sherrinford/profile/GET_PROFILES_REQUEST'
export const GET_PROFILES_SUCCESS = 'sherrinford/profile/GET_PROFILES_SUCCESS'
export const GET_PROFILES_ERROR = 'sherrinford/profile/GET_PROFILES_ERROR'

export const VALIDATE_PROFILE_REQUEST = 'getcraft/profile/VALIDATE_PROFILE_REQUEST'
export const VALIDATE_PROFILE_SUCCESS = 'getcraft/profile/VALIDATE_PROFILE_SUCCESS'
export const VALIDATE_PROFILE_ERROR = 'getcraft/profile/VALIDATE_PROFILE_ERROR'

const initialState = {
  profiles: {
    currentPage: 1,
    count: 0,
    totalPages: 1,
    rows: [],
  },
}

export default createReducer(initialState, {
  [GET_PROFILES_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_PROFILES_SUCCESS]: (state, profiles) => ({
    ...state,
    isLoading: false,
    profiles,
  }),
  [GET_PROFILES_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
})

export const getProfiles = () => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_PROFILES_REQUEST,
      GET_PROFILES_SUCCESS,
      GET_PROFILES_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/profile',
      authorization: token,
    },
  }
}

export function getValidateProfile(profileId, cb = () => {}) {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      VALIDATE_PROFILE_REQUEST,
      VALIDATE_PROFILE_SUCCESS,
      VALIDATE_PROFILE_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/profile/${profileId}/validate`,
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}
